import React from 'react'
import Toggle from 'react-toggle'

class SwitchButton extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isChecked: props.isChecked
    }
  }

  componentWillReceiveProps = (newProps) => {
    this.setState({ isChecked: newProps.isChecked })
  }

  componentWillMount = () => {
    this.setState({ isChecked: this.props.isChecked })
  }

  _handleChange = () => {
    this.setState({ isChecked: !this.state.isChecked })
    const event = {
      target: {
        value: !this.state.isChecked
      }
    }
    this.props.onChange(event)
  }

  render () {
    return (
      <label>
        <Toggle
          checked={this.state.isChecked}
          value={this.props.label}
          onChange={this._handleChange} />
        <span>{this.props.label}</span>
      </label>
    )
  }
}

export default SwitchButton



// WEBPACK FOOTER //
// ./src/Components/SwitchButton.js